/*@ngInject*/
export default ['$resource','BASE_URL', function ($resource, BASE_URL){ return $resource(BASE_URL + "/account/:resource", {}, {
    stats: {method: "GET", params: {resource: "stats"}},
    plan: {method: "GET", params: {resource: "plan"}},
    limits: {method: "GET", params: {resource: "limits"}},
})}];
